/*
 * This file serves as the root component of our app.
 */

import React, { useEffect } from "react";
import { BrowserRouter } from "react-router";
import { ToastContainer } from "react-toastify";
import SplashScreen from "./components/loading/AppInitializing";
import useInitializeApp from "./hooks/useInitializeApp";
import AppRoutes from "./router";
import "./static/css/global.css";


function App() { 
  const { 
    isInitializing, 
    isOffline, 
    progress, 
    statusMessage, 
    error, 
    maxRetries, 
    retryCount, 
    restart 
  } = useInitializeApp();

  useEffect(() => {
    window.addEventListener("scroll", enableStickyHeader);

    function enableStickyHeader() {
      const target = document.querySelector(".header-sticky");

      if(!target) {
        return;
      }

      if(window.scrollY > 300) {
        target.classList.add("sticky");
      } else {
        target.classList.remove("sticky");
      }
    }

    return () => window.removeEventListener("scroll", enableStickyHeader);
  }, []);

  if(isInitializing) {
    return (
      <SplashScreen error={error} 
        isLoading={isInitializing} 
        isOffline={isOffline}
        progress={progress} 
        statusMessage={statusMessage} 
        maxRetries={maxRetries}
        retryCount={retryCount}
        restart={restart}
      />
    );
  }

  return (
    <BrowserRouter>
      <AppRoutes />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
